import React, { Component } from 'react'
import MainMenu from '../../../../../Components/MainMenu'
import StatsBody from './Components/StatsBody'
import SquadBody from './Components/SquadBody'
import MatchesBody from './Components/MatchesBody'
import StandingsBody from './Components/StandingsBody'
import Utils from '../../../../../../../utils/Utils'
import { getNodeCode, getTabsSecondLevel } from '../../../../../utils'
import { getStatisticsCountryDetails } from '../../../../../services/CountryDetailsServices/getStatisticsCountryDetails'
import { getLineupsCountryDetails } from '../../../../../services/CountryDetailsServices/getLineupsCountryDetails'
import { match } from 'assert'
import { getMatchesCountryDetail } from '../../../../../services/CountryDetailsServices/getMatchesCountryDetail'
import { tabsSecondLevelCountryDetails } from '../constants'
import Device from '../../../../../../../devices/device'
import './_styles.scss'


let TAB_VIEW_PARAM = {
  stats:  'statistics',
  squad:  'lineups',
  matches: 'matchesTeams',
}

/**
 * CountryDetailsBody
 * Contenedor del cuerpo de la modal de detalle de país.
 * Diseño: Figma node 126:18477 — Large/Contenedor
 *
 * Props:
 *  children       {node}   — contenido scrolleable
 *  bodyRef        {func}   — ref para el div de scroll
 *  onScrollKeyDown {func}  — handler del ScrollIndicator
 *  scrollRatio    {number} — posición del thumb (0-1)
 *  trackHeightRem {number} — alto del track en rem
 *  thumbHeightRem {number} — alto del thumb en rem
 */
class CountryDetailsBody extends Component {
  constructor (props) {
    super(props)
    this.state = { 
      activeTab: 'stats',
      dataStats: null,
      dataLineups: null,
      matchesTeams: []
    }
    this.onChangeTab = this.onChangeTab.bind(this)
    this.handleMainMenuDown = this.handleMainMenuDown.bind(this)

    const code = getNodeCode()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
    this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
    this.teamViewParam = TAB_VIEW_PARAM['stats']

    this.tabs = getTabsSecondLevel(tabsSecondLevelCountryDetails)
    this.tabs = this.tabs.map(tab =>({id: tab.id, title: tab.label}))
    this.keys = Device.getDevice().getKeys()
  }
  
  async componentDidMount() {
    const { dataStats } = (await getStatisticsCountryDetails(this.idLeague, this.teamViewParam, this.props.countryId)) || {}
    this.setState({ dataStats: dataStats })
  }

  async componentDidUpdate (prevProps, prevState) {
    if (prevState.activeTab !== this.state.activeTab) {
      let newParam = TAB_VIEW_PARAM[this.state.activeTab]
      if (newParam === 'statistics') {
        const { dataStats } = (await getStatisticsCountryDetails(this.idLeague, newParam, this.props.countryId)) || {}
        this.setState({ dataStats: dataStats })
      } else if (newParam === 'lineups') {
        const { dataLineups, team } = (await getLineupsCountryDetails(this.idLeague, newParam, this.props.countryId)) || {}
        this.setState({ dataLineups: dataLineups, team: team })
      }else if (newParam === 'matchesTeams') {
        const matches = (await getMatchesCountryDetail(this.idLeague, newParam, this.props.countryId)) || []
        this.setState({ matchesTeams: matches })
      }
    }
  }

  onChangeTab (tabId) {
    if (tabId === this.state.activeTab) return
    this.setState({ activeTab: tabId })
  }

  handleMainMenuDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey === 'UP') {
      e.preventDefault()
      e.stopPropagation()
      let favorite = document.querySelector('.country-details-header__favorite-country-wrapper')
      if (favorite) favorite.focus()
      return
    }
    if (currentKey !== 'DOWN') return
    if (this.state.activeTab === 'stats') {
      e.preventDefault()
      e.stopPropagation()
      let subTab = document.querySelector('.stats-body__submenu-tab--active, .stats-body__submenu-tab--active-focused')
      if (subTab) subTab.focus()
    } else if (this.state.activeTab === 'squad') {
      e.preventDefault()
      e.stopPropagation()
      let toggle = document.querySelector('.squad-body__header .toggle')
      if (toggle) toggle.focus()
    } else if (this.state.activeTab === 'matches') {
      e.preventDefault()
      e.stopPropagation()
      let firstCard = document.querySelector('.matches-body__scroll .match-card')
      if (firstCard) firstCard.focus()
    } else if (this.state.activeTab === 'standings') {
      e.preventDefault()
      e.stopPropagation()
      let scrollbar = document.querySelector('.standings-body__group-scrollbar, .standings-body__ranking-scrollbar')
      if (scrollbar) scrollbar.focus()
    }
  }

  render () {
    const { activeTab, dataStats, dataLineups, matchesTeams } = this.state
    
    return (
      <div className='country-details-body'>
        <div className='country-details-body__tabs' onKeyDownCapture={this.handleMainMenuDown}>
          <MainMenu
            items={this.tabs}
            activeTab={activeTab}
            onItemClick={this.onChangeTab}
          />
        </div>
        {activeTab === 'stats' && (
          <StatsBody dataStats={dataStats} mainMenuLabel={this.props.mainMenuLabel} parentTabLabel={this.props.parentTabLabel} childTabLabel={this.props.childTabLabel}>
          </StatsBody>
        )}
        {activeTab === 'squad' && (
          <SquadBody dataLineups={this.state.dataLineups} team={this.state.team} mainMenuLabel={this.props.mainMenuLabel} parentTabLabel={this.props.parentTabLabel} childTabLabel={this.props.childTabLabel}>
          </SquadBody>
        )}
        {activeTab === 'matches' && (
          <MatchesBody matchesTeams={matchesTeams} mainMenuLabel={this.props.mainMenuLabel} parentTabLabel={this.props.parentTabLabel} childTabLabel={this.props.childTabLabel}>
          </MatchesBody>
        )}
        {activeTab === 'standings' && (
          <StandingsBody countryId={this.props.countryId} mainMenuLabel={this.props.mainMenuLabel} parentTabLabel={this.props.parentTabLabel} childTabLabel={this.props.childTabLabel}>
          </StandingsBody>
        )}
      </div>
    )
  }
}

export default CountryDetailsBody




// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/index.jsx